import React from "react";
import {
	Page,
	Text,
	View,
	Document,
	StyleSheet,
	Image,
} from "@react-pdf/renderer";

// Create styles
const styles = StyleSheet.create({
	page: {
		flexDirection: "column",
		backgroundColor: "#FFFFFF",
	},
	section: {
		margin: 10,
		padding: 1,
	},
	imageSection: {
		width: 240,
		height: 300,
		alignSelf: 'center'
	},
	endSection: {
		justifyContent: 'flex-end',
		flex: 1,
		margin: 10,
		padding: 1
	}
});

// Create Document Component
/*
    data prop is an object containing following strings:
    D,
	gW,
	dimension,
	dimensionValue,
	units,
	resultString,
	created,
	note
*/
const MyDocument = ({ data }) => {
	//console.log(data);
	const {
		D,
		gW,
		dimension,
		dimensionValue,
		units,
		resultString,
		created,
		note,
	} = data;

	return (
		<Document>
			<Page size="A4" style={styles.page}>
				<View style={styles.section}>
					<Text>{created}</Text>
				</View>
				<View style={styles.imageSection}>
					<Image
						source={
							"https://www.insanehydraulics.com/library/app/img/gears.jpg"
						}
					/>
				</View>
				<View style={styles.section}>
					<Text>{`D: ${D} (${units})`}</Text>
				</View>
				<View style={styles.section}>
					<Text>{`gW: ${gW} (${units})`}</Text>
				</View>
				<View style={styles.section}>
					<Text>{`${dimension}: ${dimensionValue} (${units})`}</Text>
				</View>
				<View style={styles.section}>
					<Text>{`Calculated Displacement: ${resultString}`}</Text>
				</View>
				<View style={styles.section}>
					<Text>{`Note: ${note}`}</Text>
				</View>
				<View style={styles.endSection}>
					<Text>www.insanehydraulics.com/library/app</Text>
				</View>
			</Page>
		</Document>
	);
};

export default MyDocument;
